<mat-card *ngIf="hasData">
    <div class="chartjs-container">
        <h2 style="text-align: center;">Track Participantes vs Votantes</h2>
        <canvas baseChart 
            [datasets]="barChartData" 
            [labels]="tracks" 
            [options]="barChartOptions"
            [plugins]="barChartPlugins" 
            [legend]="barChartLegend" 
            [chartType]="barChartType">
        </canvas>
    </div>
</mat-card>